import React from 'react';

interface TifosiCrestProps {
  size?: number;
  text?: string;
  fontSize?: number;
  style?: React.CSSProperties;
}

export function TifosiCrest({ size = 30, text = 'T', fontSize, style }: TifosiCrestProps) {
  const computedFont = fontSize ?? Math.round(size * 0.6);
  return (
    <div
      className="tifosi-crest"
      style={{
        width: size,
        height: size,
        borderRadius: size,
        fontSize: computedFont,
        ...style,
      }}
      aria-label="Tifosi"
    >
      {text}
    </div>
  );
}

export default TifosiCrest;
